export enum ConnectProviderStatus {
  NOT_STARTED = 'not_started',
  WAITING_TOKEN = 'waiting_token',
  SELECTING_COMPANY = 'selecting_company',
  SYNCING = 'syncing',
  ERROR = 'error',
  SUCCESS = 'success',
  FILE_ADDED = 'file-added',
}
